import React from "react";

const IdIcon = ({ className, size = 20 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0079 8.95833C8.05452 8.95833 6.46619 7.36917 6.46619 5.41667C6.46619 3.46417 8.05452 1.875 10.0079 1.875C11.9612 1.875 13.5495 3.46417 13.5495 5.41667C13.5495 7.36917 11.9612 8.95833 10.0079 8.95833ZM10.0079 3.125C8.74369 3.125 7.71619 4.1525 7.71619 5.41667C7.71619 6.68083 8.74369 7.70833 10.0079 7.70833C11.272 7.70833 12.2995 6.68083 12.2995 5.41667C12.2995 4.1525 11.2712 3.125 10.0079 3.125ZM13.3311 18.125H6.66954C4.65287 18.125 3.54199 17.0209 3.54199 15.0159C3.54199 12.7984 4.79699 10.2083 8.33366 10.2083H11.667C15.2037 10.2083 16.4587 12.7975 16.4587 15.0159C16.4587 17.0209 15.3478 18.125 13.3311 18.125ZM8.33366 11.4583C5.04783 11.4583 4.79199 14.1809 4.79199 15.0159C4.79199 16.3192 5.3537 16.875 6.66954 16.875H13.3311C14.6469 16.875 15.2087 16.3192 15.2087 15.0159C15.2087 14.1817 14.9528 11.4583 11.667 11.4583H8.33366Z"
      fill="#7A7A7A"
    />
  </svg>
);

export default IdIcon;
